<template>
  <div>
    <unicom-linha>
      <unicom-coluna sm="auto">
        <div class="medio segunda-cor-fonte">
          {{
            objetoObservacao.usuarioCriacao
              ? objetoObservacao.usuarioCriacao.nomeComPapel
              : ""
          }}
        </div>
      </unicom-coluna>
      <unicom-coluna sm="auto" class="ml-auto">
        <div class="medio segunda-cor-fonte">
          {{ $helpers.formatadorHorario(objetoObservacao.dtCriacao) }}
        </div>
      </unicom-coluna>
    </unicom-linha>
    <transition name="component-fade" mode="out-in">
      <CartaoObservacao
        v-if="objetoObservacao.id !== idEditando"
        key="VISUALIZANDO"
        ref="cartaoObservacao"
        @altura="setAltura"
        @editar="editarObservacao"
        @excluir="excluirCartao"
        :observacao="objetoObservacao.texto"
      />
      <CartaoEdicaoObservacao
        v-else
        key="EDITANDO"
        @editar="editarObservacao"
        @salvar-observacao="salvarObservacao"
        :alturaCartao="alturaCartaoVisu"
        :observacao="objetoObservacao.texto"
      />
    </transition>
  </div>
</template>

<script>
import CartaoObservacao from "./CartaoObservacao";
import CartaoEdicaoObservacao from "./CartaoEdicaoObservacao";

export default {
  components: {
    CartaoObservacao,
    CartaoEdicaoObservacao
  },
  props: {
    objetoObservacao: {
      type: Object,
      default: () => {
        return {
          nome: "",
          data: "",
          observacao: "",
          id: 0
        };
      }
    }
  },
  data() {
    return {
      alturaCartaoVisu: 0
    };
  },
  methods: {
    editarObservacao(editando) {
      if (editando && this.idEditando !== 0) {
        this.$store.dispatch("setMostrarModalConfirmarResumido", {
          mostrarModalConfirmar: true,
          callbackModalConfirmar: () => {
            this.editarObservacaoUnico();
            this.$store.commit("setMostrarModalConfirmar", false);
          },
          tituloModalConfirmar: "Deseja sair da edição?",
          mensagemModalConfirmar:
            "Existe uma edição em andamento. Ao sair, as alterações realizadas serão perdidas.",
          textoBotaoModalConfirmar: "EDITAR",
          tipoBotaoModalConfirmar: "importante"
        });
      } else if (editando) {
        this.editarObservacaoUnico();
      } else {
        this.$store.commit("setIdEditando", 0);
      }
    },
    editarObservacaoUnico() {
      this.$store.commit(
        "setOffsetTopElementoEditando",
        this.$refs.cartaoObservacao.$el.offsetTop
      );
      this.$emit("mover-scroll", this.$refs.cartaoObservacao);
      this.$store.commit("setIdEditando", this.objetoObservacao.id);
    },
    salvarObservacao(observacao) {
      let objetoEdicao = {
        idObservacao: this.objetoObservacao.id,
        objetoObservacao: {
          texto: observacao
        }
      };
      this.$store.dispatch("editarObservacao", objetoEdicao);
    },
    excluirCartao() {
      this.$store.dispatch("excluirObservacao", this.objetoObservacao.id);
    },
    setAltura(altura) {
      this.alturaCartaoVisu = altura;
    }
  },
  computed: {
    idEditando() {
      return this.$store.getters.getIdEditando;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./LinhaObservacao";

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
